<input
  #fileInput
  hidden
  type="file"
  [accept]="acceptFiles"
  (change)="handleFile($event.target.files[0])"
/>

<app-driveb-option-menu
  [options]="options"
  [positionTooltip]="positionTooltip"
  [tooltip]="tooltip"
  [fontIcon]="fontIcon"
  (onClickItem)="openUploadDialog($event)"
  [uploadButtonText]="uploadButtonText"
></app-driveb-option-menu>

<app-driveb-file-details
  *ngIf="this.file"
  [file]="this.file"
  (onClickSave)="save()"
  (onClickRemove)="removeFile()"
></app-driveb-file-details>
